"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectBoxWrapper = exports.GroupedSelectBoxWrapper = void 0;
var React = _interopRequireWildcard(require("react"));
var _alloySelectBox = _interopRequireWildcard(require("@adsk/alloy-select-box"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const GroupedSelectBoxWrapper = _ref => {
  let {
    ...props
  } = _ref;
  const styledGroupedSelectBoxComp = /*#__PURE__*/React.createElement(_alloySelectBox.GroupedSelectBox, _extends({}, props, {
    clearInputOnSelect: true,
    menuStyle: {
      width: "100%"
    }
  }), props => /*#__PURE__*/React.createElement(_alloySelectBox.default, props));
  return props.name ?
  /*#__PURE__*/
  // @ts-ignore
  React.createElement("span", {
    name: props.name
  }, styledGroupedSelectBoxComp) : styledGroupedSelectBoxComp;
};
exports.GroupedSelectBoxWrapper = GroupedSelectBoxWrapper;
const SelectBoxWrapper = _ref2 => {
  let {
    ...props
  } = _ref2;
  const styledSelectBoxComp = /*#__PURE__*/React.createElement(_alloySelectBox.default
  /** we set style as maxHeight: 113 because we want to show at most 3 lines of tokens by default */, _extends({
    style: {
      maxHeight: 113
    }
  }, props, {
    clearInputOnSelect: true,
    menuStyle: {
      width: "100%",
      ...props.menuStyle
    }
  }));
  return props.name ?
  /*#__PURE__*/
  // @ts-ignore
  React.createElement("span", {
    name: props.name
  }, styledSelectBoxComp) : styledSelectBoxComp;
};
exports.SelectBoxWrapper = SelectBoxWrapper;
//# sourceMappingURL=SelectBoxWrapper.js.map